import { useEffect, useState } from "react"
import { useWebContext } from "../../_contexts"
import { useAxios } from "../../_utility"
import { requestDetailsDataProps, requestHeadInfoProps } from "./type"

const apiUrl = `${process.env.REACT_APP_AMP_API_SLUG}`
const getRequestDetailUrl = `${apiUrl}/ampPages/viewRequest`
const getRequestSubmitUrl = `${apiUrl}/ampPages/submitRequest`
const getRequestApprovalUrl = `${apiUrl}/ampPages/approveRequest`

export function useApiRequestDetail(id: string) {
  const [requestInfo, setRequestInfo] = useState<requestHeadInfoProps>()
  const [requestDataList, setRequestDataList] = useState<requestDetailsDataProps[]>()
  const { response, isLoading, error, fetch } = useAxios({
    url: `${getRequestDetailUrl}`,
  })

  useEffect(() => {
    if (response !== null) {
      const { result: { header, lines } } = response
      setRequestInfo(header[0])
      setRequestDataList(lines)
    }
  }, [response])

  useEffect(() => {
    fetch({
      params: {
        requestId: id
      }
    })
  }, [])

  return { requestInfo, requestDataList, isLoading, error }
}

export function useApiRequestSubmit(id: string, callback: any) {
  const [RequestStatus, setRequestStatus] = useState<string>()
  const { notification } = useWebContext()
  const { response, isLoading: isSendingRequest, error, fetch } = useAxios({
    url: `${getRequestSubmitUrl}`,
    method: 'post',
    dataType: 'json'
  })

  function fetchSubmitRequest(RequestData: string) {
    setRequestStatus(RequestData)
    fetch({
      data: {
        status: RequestData,
        message: '',
        requestId: id
      }
    })
  }
  useEffect(() => {
    error && notification(`[Error: ${error.status}] Somthing Went Wrong!`, 'error')
  }, [error])

  useEffect(() => {
    if (response) {
      notification(response.description, 'success');
      callback(RequestStatus)
    }
  }, [response])
  return { fetchSubmitRequest, isSendingRequest }
}

export function useApiRequestApproval(id: string, callback: any) {
  const { notification } = useWebContext()
  const { response, isLoading: isApprovingRequest, error, fetch } = useAxios({
    url: `${getRequestApprovalUrl}`,
    method: 'post',
    dataType: 'json'
  })

  function fetchApprovalRequest() {
    fetch({
      data: {
        requestId: id,
        status: 'APPROVED', // APPROVED | REJECTED
        message: '',
      }
    })
  }
  useEffect(() => {
    error && notification(`[Error: ${error.status}] Somthing Went Wrong!`, 'error')
  }, [error])

  useEffect(() => {
    if (response) {
      notification(`Request Approved successfully`, 'success')
      callback('APPROVED')
    }

  }, [response])
  return { fetchApprovalRequest, isApprovingRequest }
}